module.exports = __webpack_public_path__ + "img/gard_vertical_3.766af1d7.png";